<template>
  <div>
    <Alert show-icon>若用户不存在，将为该用户注册账号后加入研究；若用户已存在，将直接加入研究。</Alert>
    <Form ref="form" :model="model" :label-width="100" :rules="ruleValidate">
      <Form-item prop="role" label="角色">
        <Select v-model="model.role" filterable clearable>
          <Option v-for="(role, key) in roles" :value="key" :key="key" :label="role"></Option>
        </Select>
      </Form-item>
      <Form-item prop="email" label="邮箱">
        <Input type="text" v-model="model.email"></Input>
      </Form-item>
      <Form-item prop="username" label="用户名">
        <Input type="text" v-model="model.username"></Input>
      </Form-item>
      <Form-item prop="name" label="姓名">
        <Input type="text" v-model="model.name"></Input>
      </Form-item>
      <Form-item>
        <Button type="primary" @click="handleSubmit('form')" long>注册用户</Button>
      </Form-item>
    </Form>
  </div>
</template>

<script>
import { SignupMember, GetAssistItems } from '@/api/study.team'

export default {
  name: 'plus-mumber',
  data: function () {
    return {
      model: {
        role: '',
        email: '',
        username: '',
        study_id: '',
        name: ''
      },
      loading: false,
      roles: {},
      sites: {},
      users: {},
      ruleValidate: {
        role: [{
          required: true,
          message: '角色不能为空',
          trigger: 'change'
        }],
        email: [{
          required: true,
          message: '注册邮箱不能为空',
          trigger: 'blur'
        }, {
          type: 'email',
          message: '邮箱格式不正确',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '真实姓名不能为空',
          trigger: 'blur'
        }],
        username: [{
          required: true,
          message: '用户名不能为空',
          trigger: 'blur'
        }]
      }
    }
  },
  created: function () {
    this.getItems()
  },
  methods: {
    handleSubmit: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.postForm()
        }
      })
    },
    getItems: function () {
      const id = this.$route.params.id
      GetAssistItems(id).then(async res => {
        this.statuses = res.statuses
        this.roles = res.roles
      })
    },
    postForm: function () {
      this.model.study_id = this.$route.params.id
      SignupMember(this.model).then(async res => {
        if (res.error) {
          this.$Message.error(res.error)
        } else {
          this.$emit('refresh')
          this.$Message.success(res)
        }
      })
    }
  }
}
</script>

<style>
.text-center{
  text-align: center;
}
</style>
